import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as whom from "./style.module.scss";
export const WhomEng = ({ video, poster, duration }) => {
  React.useEffect(() => {
    const vid = document.querySelector('video');
    vid.controls = false;
    vid.addEventListener('click', function() {
      if (vid.paused) {
        vid.play();
      } else {
        vid.pause();
      }
    });
  }, []);
  return (
    <section className={whom.whom}>
      <div className="container">
        <h2 className={main.titleH2}>Кураторское сопровождение&nbsp;&mdash; удачное решение, если вам:</h2>
        <div className={whom.whom__points}>
          <div className={whom.whom__point}>трудно самостоятельно организовать время занятий;</div>
          <div className={whom.whom__point}>не&nbsp;хватает мотивации пройти курс до&nbsp;конца;</div>
          <div className={whom.whom__point}>легче осваивать новый материал в&nbsp;группе единомышленников;</div>
          <div className={whom.whom__point}>для плодотворной работы нужна обратная связь и&nbsp;контроль.</div>
        </div>
        <div className={whom.whom__block}>
          <div className={whom.organized}>
            <div className={whom.organized__title}>Как организовано:</div>
            <div>
              <div className={whom.organized__blockItem}>
                <strong>Чат в&nbsp;Телеграме</strong> на&nbsp;10 учеников и&nbsp;куратора
              </div>
              <div className={whom.organized__blockItem}>
                Продолжительность участия&nbsp;&mdash; <strong>{duration}</strong>
              </div>
              <div className={whom.organized__blockItem}>
                Вы&nbsp;можете выбрать частоту занятий: <strong>3&nbsp;или 5&nbsp;раз в&nbsp;неделю</strong>
              </div>
              <div className={whom.organized__blockItem}>
                Ориентировочное время выполнения задания&nbsp;&mdash; <strong>60&nbsp;минут</strong>
              </div>
              <div className={whom.organized__blockItem}>
                У&nbsp;вас будет возможность задавать любые вопросы, касающиеся курса<br/>и&nbsp;<strong>получать экспертный ответ</strong>
              </div>
            </div>
          </div>
          <div className={whom.whom__img}>
            <video
              className={whom.whom__imgVideo}
              src={ video }
              poster={ poster }
              width={'360px'}
              controls
            >
              <track kind={"captions"}/>
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};
